import { useMemo } from 'react';
import { prop } from 'ramda';
import { IGameTileAsset } from 'js/hooks/games/types';
import { useUserSelector, useGameConfigurationSelector, useDeviceSelector } from 'js/store/hooks';

import placeholderImage from '../images/game_placeholder.svg';

export const useGameImageUrls = (
    { code, dynamicImageUrl, isLiveGame }: { code: string; dynamicImageUrl?: string; isLiveGame?: boolean }
): string[] => {
    const games = useGameConfigurationSelector(prop('games'));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return useMemo(() => {
        const { defaultGameImage = '', gameTileAssetsLandscape: { layout1x1 = {} as IGameTileAsset } = {} } = games?.[code] || {};
        const mainGameImage = isLoggedIn ? layout1x1.mainImage : layout1x1.guestMainImage || layout1x1.mainImage;
        const userMobileImage = layout1x1.mobileImage || layout1x1.mainImage;
        const mobileGameImage = isLoggedIn
            ? userMobileImage
            : layout1x1.guestMobileImage || layout1x1.guestMainImage || userMobileImage;
        const cmsImageUrl = (isDesktop ? mainGameImage : mobileGameImage) || defaultGameImage;

        return [
            ...isLiveGame && dynamicImageUrl ? [dynamicImageUrl] : [],
            cmsImageUrl,
            placeholderImage
        ];
    }, [code, isLiveGame, dynamicImageUrl, games, isLoggedIn, isDesktop]);
};
